// extracted by mini-css-extract-plugin
export default {"small_italic_text":"GM","wrapper":"HM","page":"IM","topblock":"JM","nextBtn":"KM","bottomnav":"LM","MyClassEnterDone":"MM","topname":"NM","text":"OM"};
    if(module.hot) {
      // 1713969935208
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  